export default __webpack_public_path__ + "static/media/logo-small.6503909b.svg";